import React, { useEffect } from 'react';
import './index.scss';
import { API_URL } from "../../../../../constants/ApplicationUrl";
import { underscoreToSpace } from '../../../../../dependencies/utils/helper';
function WealthGeneration({ data, adminScores, setAdminScores }) {

  useEffect(() => {
    setAdminScores({
      fundingObtained: data?.ScoreCard?.score?.adminScore?.fundingObtained,
      revenueGeneration: data?.ScoreCard?.score?.adminScore?.revenueGeneration,
      profitability: data?.ScoreCard?.score?.adminScore?.profitability,

    });
  }, [data]);


  const handleScoreChange = (field, value) => {
    setAdminScores((prev) => ({
      ...prev,
      [field]: Number(value),
    }));
  };
  return (
    <>
      <div className="entity-detail-inner table-card">
        <table>
          <thead>
            <tr>
              <th className="score-marks">
                <table>
                  <tr>
                    <th>
                      Wealth Generation <span>(Max Marks : 100)</span>
                    </th>
                    <th>SIH User Marks</th>
                    <th>Admin Response</th>
                    <th>Admin Marks</th>
                  </tr>
                </table>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tbody">
                <table>
                  <tr>
                    <td>
                      <div className="row-ca">
                        <div className="content">
                          <h6>Funding Obtained from any external source (Both Government & Private Funding) </h6> <span>:</span>

                        </div>
                        <div className="view-list">
                          <p>
                            {underscoreToSpace(data?.Parameters?.broadParameter?.fundingObtained)}
                            {data?.Parameters?.broadParameter?.fundingObtainedDocument ? (<a href={`${API_URL()}${data?.Parameters?.broadParameter?.fundingObtainedDocument?.publicUrl}`}
                              target="_blank"
                              rel="noopener noreferrer">View Document</a>): (null)}                           

                          </p>

                        </div>
                      </div>
                    </td>
                    <td>{data?.ScoreCard?.score?.sihScore?.fundingObtained}</td>
                    <td>
                      <select
                        className="form-select"
                        value={adminScores.fundingObtained}
                        onChange={(e) => handleScoreChange("fundingObtained", e.target.value)}
                      >
                        {data?.ScoreCard?.score ? (null):(<option value="">--Select One--</option>)}
                        <option value="10">NO FUNDING</option>
                        <option value="20">FUNDING UPTO 1CR</option>
                        <option value="30">FUNDING 1-10CR</option>
                        <option value="40">FUNDING ABOVE 10CR</option>
                      </select>
                    </td>
                    <td>{adminScores.fundingObtained}</td>
                  </tr>
                  <tr>
                    <td>
                      <div className="row-ca">
                        <div className="content">
                          <h6>Revenue Generation</h6> <span>:</span>

                        </div>
                        <div className="view-list">
                          <p>
                            {underscoreToSpace(data?.Parameters?.broadParameter?.revenueGeneration)}
                            {data?.Parameters?.broadParameter?.revenueGenerationDocument ? (<a href={`${API_URL()}${data?.Parameters?.broadParameter?.revenueGenerationDocument?.publicUrl}`}
                              target="_blank"
                              rel="noopener noreferrer">View Document</a>): (null)}
                            

                          </p>

                        </div>
                      </div>
                    </td>
                    <td>{data?.ScoreCard?.score?.sihScore?.revenueGeneration}</td>
                    <td>
                      <select
                        className="form-select"
                        value={adminScores.revenueGeneration}
                        onChange={(e) => handleScoreChange("revenueGeneration", e.target.value)}
                      >
                        {data?.ScoreCard?.score ? (null):(<option value=''>--Select One--</option>)}
                        <option value="0">NO REVENUE</option>
                        <option value="10">REVENUE UPTO 1CR</option>
                        <option value="20">REVENUE 1-10CR</option>
                        <option value="30">REVENUE ABOVE 10CR</option>

                      </select>
                    </td>
                    <td>{adminScores.revenueGeneration}</td>
                  </tr>
                  <tr>
                    <td>
                      <div className="row-ca">
                        <div className="content">
                          <h6>Profitability </h6> <span>:</span>

                        </div>
                        <div className="view-list">
                          <p>
                            {underscoreToSpace(data?.Parameters?.broadParameter?.profitability)}
                            {data?.Parameters?.broadParameter?.profitabilityDocument ? (<a href={`${API_URL()}${data?.Parameters?.broadParameter?.profitabilityDocument?.publicUrl}`}
                              target="_blank"
                              rel="noopener noreferrer">View Document</a>): (null)}
                            
                          </p>

                        </div>
                      </div>
                    </td>
                    <td>{data?.ScoreCard?.score?.sihScore?.profitability}</td>
                    <td> <select
                      className="form-select"
                      value={adminScores.profitability}
                      onChange={(e) => handleScoreChange("profitability", e.target.value)}
                    >
                      {data?.ScoreCard?.score ? (null):(<option value=''>--Select One--</option>)}
                      <option value="0">LOSS</option>
                      <option value="10">NO PROFIT NO LOSS</option>
                      <option value="20">PROFIT LATEST YEAR</option>
                      <option value="30">PROFIT 2 PLUS YEARS</option>
                    </select></td>
                    <td>{adminScores.profitability}</td>

                  </tr>

                </table>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td className="tfoot">
                <table>

                  <tr>
                    <td>
                      <h6>Sectional Marks Obtained <span>SIH User Marks </span></h6>
                    </td>
                    <td>{data?.ScoreCard?.score?.sihScore?.totalGroup2Score}</td>
                    <td>Admin Marks</td>
                    <td>{adminScores.fundingObtained + adminScores.profitability + adminScores.revenueGeneration}</td>
                    {/* <td>{data?.ScoreCard?.score?.adminScores?.totalGroup2Score}</td> */}

                  </tr>
                </table>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  )
}

export default WealthGeneration
